import colors from './colors.module.scss';

export enum Themes {
  LIGHT = 0,
  DARK,
  SYSTEM, // Add system option
}

export const grey = {
  50: colors.grey_50,
  100: colors.grey_100,
  200: colors.grey_200,
  300: colors.grey_300,
  400: colors.grey_400,
  500: colors.grey_500,
  600: colors.grey_600,
  700: colors.grey_700,
  800: colors.grey_800,
  900: colors.grey_900,
};
